import { pick } from 'lodash';
import {
  FETCH_EVENTS,
  FETCH_EVENTS_SUCCESS,
  FETCH_EVENTS_FAILURE,
  FETCH_GAMES_FOR_EVENTS,
  FETCH_GAMES_FOR_EVENTS_SUCCESS,
  FETCH_GAMES_FOR_EVENTS_FAILURE,
  CREATE_EVENT,
  CREATE_EVENT_SUCCESS,
  CREATE_EVENT_FAILURE,
  CREATE_EVENT_RESET,
  FETCH_SINGLE_EVENT,
  FETCH_SINGLE_EVENT_SUCCESS,
  FETCH_SINGLE_EVENT_FAILURE,
  SINGLE_EVENT_RESET,
  UPDATE_EVENT_SUCCESS,
  UPDATE_EVENT,
  UPDATE_EVENT_FAILURE,
  UPDATE_EVENT_RESET,
  FETCH_EVENT_AUDIT_LOGS,
  FETCH_EVENT_AUDIT_LOGS_SUCCESS,
  FETCH_EVENT_AUDIT_LOGS_FAILURE,
  EVENT_AUDIT_LOG_RESET,
  GAMES_FOR_EVENTS_RESET,
  MARK_EVENT_FOR_DELETION,
  MARK_EVENT_FOR_DELETION_SUCCESS,
  MARK_EVENT_FOR_DELETION_FAILURE,
} from '../constants';

export const defaultState = {
  // start - events list page
  events: [],
  isFetching: false,
  offset: 0,
  limit: 10,
  orderBy: null,
  totalCount: 0,
  sort: 'asc',
  isError: false,
  // end - events list page

  // start - create event page
  games: [],
  isFetchingGames: false,
  gamesError: false,
  isCreatingEvent: false,
  isCreateEventError: false,
  isCreateEventSuccess: false,
  createEventErrorMessage: null,
  // end - create event page

  // start - event details page
  event: null,
  isFetchingEvent: false,
  isFetchEventError: false,
  fetchEventErrorStatusCode: null,

  isUpdatingEvent: false,
  isUpdateEventSuccess: false,
  isUpdateEventError: false,

  isMarkingForDeletion: false,
  isMarkingForDeletionSuccess: false,
  isMarkingForDeletionError: false,
  // end - event details page

  // start - audit trail page
  auditLogs: [],
  isFetchingAuditLogs: false,
  isFetchAuditLogsError: false,
  auditLogsTotalCount: 0,
  auditLogsOffset: 0,
  auditLogsLimit: 10,
  // end - audit trail page
};

function eventsReducer(state = defaultState, action) {
  switch (action.type) {
    case FETCH_EVENTS: {
      const {
        offset, limit, orderBy, sort,
      } = action.payload;

      return {
        ...state,
        events: defaultState.events,
        isFetching: true,
        isError: false,
        offset,
        limit,
        orderBy,
        sort,
      };
    }

    case FETCH_EVENTS_SUCCESS: {
      const { events, totalCount, offset } = action.payload;

      return {
        ...state,
        events,
        isFetching: false,
        isError: false,
        totalCount,
        offset,
      };
    }

    case FETCH_EVENTS_FAILURE: {
      return {
        ...state,
        isFetching: false,
        isError: true,
      };
    }

    case FETCH_GAMES_FOR_EVENTS: {
      return {
        ...state,
        isFetchingGames: true,
        gamesError: false,
      };
    }

    case FETCH_GAMES_FOR_EVENTS_SUCCESS: {
      const { games } = action.payload;

      return {
        ...state,
        games,
        isFetchingGames: false,
        gamesError: false,
      };
    }

    case FETCH_GAMES_FOR_EVENTS_FAILURE: {
      return {
        ...state,
        isFetchingGames: false,
        gamesError: true,
      };
    }

    case GAMES_FOR_EVENTS_RESET: {
      return {
        ...state,
        games: defaultState.games,
        isFetchingGames: false,
        gamesError: false,
      };
    }

    case CREATE_EVENT: {
      return {
        ...state,
        isCreatingEvent: true,
        isCreateEventError: false,
        createEventErrorMessage: null,
      };
    }

    case CREATE_EVENT_SUCCESS: {
      return {
        ...state,
        isCreatingEvent: false,
        isCreateEventSuccess: true,
        isCreateEventError: false,
        createEventErrorMessage: null,
      };
    }

    case CREATE_EVENT_FAILURE: {
      const { errorMessage } = action.payload;

      return {
        ...state,
        isCreatingEvent: false,
        isCreateEventError: true,
        createEventErrorMessage: errorMessage,
      };
    }

    case CREATE_EVENT_RESET: {
      return {
        ...state,
        isCreatingEvent: false,
        isCreateEventSuccess: false,
        isCreateEventError: false,
        createEventErrorMessage: null,
      };
    }

    case FETCH_SINGLE_EVENT: {
      return {
        ...state,
        event: null,
        isFetchingEvent: true,
        isFetchEventError: false,
      };
    }

    case FETCH_SINGLE_EVENT_SUCCESS: {
      const { event } = action.payload;

      return {
        ...state,
        event,
        isFetchingEvent: false,
        isFetchEventError: false,
      };
    }

    case FETCH_SINGLE_EVENT_FAILURE: {
      const { statusCode } = action.payload;

      return {
        ...state,
        isFetchingEvent: false,
        isFetchEventError: true,
        fetchEventErrorStatusCode: statusCode,
      };
    }

    case SINGLE_EVENT_RESET: {
      return {
        ...state,
        ...pick(
          defaultState,
          'event',
          'isFetchingEvent',
          'isFetchEventError',
          'fetchEventErrorStatusCode',
        ),
      };
    }

    case UPDATE_EVENT: {
      return {
        ...state,
        isUpdatingEvent: true,
        isUpdateEventSuccess: false,
        isUpdateEventError: false,
      };
    }

    case UPDATE_EVENT_SUCCESS: {
      const { event } = action.payload;

      return {
        ...state,
        event,
        isUpdatingEvent: false,
        isUpdateEventSuccess: true,
        isUpdateEventError: false,
      };
    }

    case UPDATE_EVENT_FAILURE: {
      return {
        ...state,
        isUpdatingEvent: false,
        isUpdateEventSuccess: false,
        isUpdateEventError: true,
      };
    }

    case MARK_EVENT_FOR_DELETION: {
      const { eventName } = action.payload;
      console.log('marking event for deletion', eventName);
      return {
        ...state,
        eventName,
        isMarkingForDeletion: true,
        isMarkingForDeletionSuccess: false,
        isMarkingForDeletionError: false,
      };
    }

    case MARK_EVENT_FOR_DELETION_FAILURE: {
      return {
        ...state,
        isMarkingForDeletion: false,
        isMarkingForDeletionSuccess: false,
        isMarkingForDeletionError: true,
      };
    }

    case MARK_EVENT_FOR_DELETION_SUCCESS: {
      return {
        ...state,
        isMarkingForDeletion: false,
        isMarkingForDeletionSuccess: true,
        isMarkingForDeletionError: false,
      };
    }

    case UPDATE_EVENT_RESET: {
      return {
        ...state,
        isUpdatingEvent: false,
        isUpdateEventSuccess: false,
        isUpdateEventError: false,
      };
    }

    case FETCH_EVENT_AUDIT_LOGS: {
      return {
        ...state,
        auditLogs: defaultState.auditLogs,
        isFetchingAuditLogs: true,
        isFetchAuditLogsError: false,
        auditLogsLimit: action.payload.limit,
      };
    }

    case FETCH_EVENT_AUDIT_LOGS_SUCCESS: {
      const { auditLogs, totalCount, offset } = action.payload;

      return {
        ...state,
        auditLogs,
        isFetchingAuditLogs: false,
        isFetchAuditLogsError: false,
        auditLogsTotalCount: totalCount,
        auditLogsOffset: offset,
      };
    }

    case FETCH_EVENT_AUDIT_LOGS_FAILURE: {
      return {
        ...state,
        isFetchingAuditLogs: false,
        isFetchAuditLogsError: true,
      };
    }

    case EVENT_AUDIT_LOG_RESET: {
      return {
        ...state,
        ...pick(
          defaultState,
          'auditLogs',
          'isFetchingAuditLogs',
          'isFetchAuditLogsError',
          'auditLogsTotalCount',
          'auditLogsOffset',
          'auditLogsLimit',
        ),
      };
    }

    default:
      return state;
  }
}

export default eventsReducer;



// WEBPACK FOOTER //
// ./src/js/redux/reducers/eventsReducer.js